<template>
  <div>
    <h3>{{ record.product ? record.product.product_name_en : '' }}</h3>

    <div v-if="isStockInShow">
      <h6 class="ts-uppercase ts-bg-blue-300 ts-p-2 ts-mt-3">
        {{ $t('productProfile.stockIn') }}
      </h6>
      <StockIn :value="record.stock_in" />
    </div>
    <div>
      <h6 class="ts-uppercase ts-bg-blue-300 ts-p-2 ts-mt-3">
        {{ $t('productProfile.statusAndLocation') }}
      </h6>
      <StatusLocation :value="record" />
    </div>
    <div v-if="movementHistory">
      <h6 class="ts-uppercase ts-bg-blue-300 ts-p-2 ts-mt-3">
        {{ $t('productProfile.serialMovementHistory') }} (Serial :{{
          movementHistory[0].serial_no
        }})
      </h6>
      <SerialMovementHistory :values="movementHistory" />
    </div>
    <div v-if="isReplacementShow">
      <h6 class="ts-uppercase ts-bg-blue-300 ts-p-2 ts-mt-3">
        {{ $t('productProfile.replacementHistory') }}
      </h6>
      <template v-for="(r, index) in record.replacements">
        <ReplacementSerialHistory :value="r" :key="index" />
        <hr />
      </template>
    </div>
    <!-- <h4 class="ts-text-gray-400 ts-text-center" v-else>{{ $t('productProfile.notFound') }}</h4> -->
  </div>
</template>

<script>
import ReplacementSerialHistory from './replacement-serial-history.vue'
import StatusLocation from './status-location.vue'
import StockIn from './stock-in.vue'
import SerialMovementHistory from './serial-movement-history.vue'
export default {
  name: 'viewSerialHistory',
  props: ['record', 'movementHistory'],
  components: {
    ReplacementSerialHistory,
    StatusLocation,
    StockIn,
    SerialMovementHistory,
  },
  computed: {
    isReplacementShow() {
      if (this.record.replacements || this.record.replacements != undefined) {
        return this.record.replacements.length
      }
      return false
    },
    isStockInShow() {
      if (this.record.stock_in || this.record.stock_in != undefined) {
        return !_.isEmpty(this.record.stock_in)
      }
      return false
    },
  },
}
</script>